document.addEventListener('DOMContentLoaded', function () {
  var slider = document.querySelector('.announcement-slider');
  if (!slider) return;

  var slides = slider.querySelectorAll('.announcement-slide');
  if (slides.length < 2) return;

  var speed = parseInt(slider.dataset.speed) || 5000;
  var currentIndex = 0;
  var intervalId = null;

  function nextSlide() {
    slides[currentIndex].classList.remove('active');
    slides[currentIndex].setAttribute('aria-hidden', 'true');
    currentIndex = (currentIndex + 1) % slides.length;
    slides[currentIndex].classList.add('active');
    slides[currentIndex].removeAttribute('aria-hidden');
  }

  function startSlider() {
    if (!intervalId) intervalId = setInterval(nextSlide, speed);
  }

  function stopSlider() {
    if (intervalId) { clearInterval(intervalId); intervalId = null; }
  }

  startSlider();

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { stopSlider(); } else { startSlider(); }
  });
});
